/* eslint-disable jsx-a11y/no-onchange */
import React, { ChangeEvent, useCallback } from "react";
import classNames from "classnames";

import styles from "./style.module.scss";
import { MessageID } from "../../i18n/types";
import { useI18n } from "../../i18n";

export interface SelectFieldOption {
  name: string;
  value: string;
  disabled?: boolean;
}

export interface TextFieldProps {
  className?: string;
  inputClassname?: string;
  labelMessageId: MessageID;
  inputName: string;
  placeholderMessageID?: MessageID;
  onSelectChange?: (text: string) => void;
  value: string | null;
  options: SelectFieldOption[];
  autoComplete?: string;
  alertText?: string;
  hintText?: string;
  disabled?: boolean;
}

const SelectField: React.FC<TextFieldProps> = props => {
  const i18n = useI18n();
  const {
    className,
    inputClassname,
    labelMessageId,
    inputName,
    placeholderMessageID,
    alertText,
    hintText,
    value,
    onSelectChange,
    autoComplete,
    disabled,
    options,
  } = props;
  const handleTextChange = useCallback(
    (event: ChangeEvent<HTMLSelectElement>) => {
      if (onSelectChange) {
        onSelectChange(event.currentTarget.value);
      }
    },
    [onSelectChange]
  );
  const isDisabled = disabled || false;
  return (
    <div className={classNames(styles.textField, className)}>
      <label className={styles.title}>{i18n.translate(labelMessageId)}</label>
      <select
        name={inputName}
        placeholder={
          placeholderMessageID != null
            ? i18n.translate(placeholderMessageID)
            : undefined
        }
        value={value ? value : ""}
        onChange={handleTextChange}
        className={classNames(styles.select, inputClassname, {
          [styles.error]: alertText && alertText !== "",
          [styles.disabled]: isDisabled,
        })}
        autoComplete={autoComplete}
        disabled={isDisabled}
      >
        {options.map(o => (
          <option key={o.value} value={o.value} disabled={o.disabled}>
            {o.name}
          </option>
        ))}
      </select>
      <p className={styles.hintText}>{hintText ? hintText : ""}</p>
      <p className={styles.alertText}>{alertText ? alertText : ""}</p>
    </div>
  );
};

export default SelectField;
